var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search_error"},[(_vm.showNetErr)?_c('div',{staticClass:"net_wrap"},[_c('img',{attrs:{"src":require("../../assets/images/parent-course/search-nodata.png"),"alt":"searchNodata"}}),_c('p',[_vm._v("哎呀，网络开小差了~")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }